module.exports = __webpack_public_path__ + "img/network-5.ee7f663d.png";